import React, { PropsWithChildren } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { checkFeatureGate } from '../Statsig/utils';

const QueryClientProviderInit = ({ children }: PropsWithChildren<{}>) => {
  const queryClient = checkFeatureGate(
    'manage_ui_should_disable_refetch_on_window_focus',
  )
    ? new QueryClient({
        defaultOptions: {
          queries: {
            retry: false,
            refetchOnWindowFocus: false,
          },
        },
      })
    : new QueryClient({
        defaultOptions: {
          queries: {
            retry: false,
          },
        },
      });
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};

export default QueryClientProviderInit;
